import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import {
  VFText,
  VFButton,
  Icon,
  IconTypes,
  IconTypesValues,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { colorPropType } from '@vfgroup-oneplatform/foundation/Utils/PropTypesValidators';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './ListItem.styles';

const ListItem = ({
  title,
  buttonType,
  onPress,
  containerStyle,
  textStyle,
  buttonDisabled,
  buttonText,
  buttonStyle,
  buttonDisabledStyle,
  buttonTextStyle,
  buttonDisabledTextStyle,
  isClickable,
  leftIconType,
  leftIconName,
  leftIconSize,
  leftIconColor,
  leftIconStyle,
  showRightIcon,
  rightIconType,
  rightIconName,
  rightIconSize,
  rightIconColor,
  rightIconStyle,
  index,
  images,
  itemAccessibilityLabel,
  itemIconAccessibilityLabel,
  itemTitleAccessibilityLabel,
  itemArrowAccessibilityLabel,
  itemButtonAccessibilityLabel,
  itemRightIconAccessibilityLabel,
  theme,
  blackTint = true,
  ...props
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={!isClickable}
      style={[styles.itemContainerStyle(theme), containerStyle]}
      accessibilityLabel={itemAccessibilityLabel}
      testID={itemAccessibilityLabel}
      accessible={false}
      {...props}
    >
      <View
        style={styles.itemImageTextContainerStyle}
        testID={FrameworkTestKeys.dashboardListItemView}
      >
        <Icon
          type={leftIconType}
          name={images[leftIconName]}
          size={leftIconSize}
          color={leftIconColor}
          style={[leftIconStyle, { tintColor: blackTint ? theme.colors.textColor : null }]}
          accessibilityLabel={itemIconAccessibilityLabel}
          testID={itemIconAccessibilityLabel}
        />
        <VFText
          style={[styles.itemTextStyle(theme), textStyle]}
          i18nKey={title}
          testKey={itemTitleAccessibilityLabel}
        />
      </View>
      {showRightIcon && (
        <Icon
          type={rightIconType}
          name={images[rightIconName]}
          color={rightIconColor}
          size={rightIconSize}
          style={rightIconStyle}
          accessibilityLabel={itemRightIconAccessibilityLabel}
          testID={itemRightIconAccessibilityLabel}
        />
      )}
      {buttonText ? (
        <VFButton
          type={buttonType}
          title={buttonText}
          onPress={onPress}
          disabled={buttonDisabled}
          style={buttonStyle}
          disabledStyle={buttonDisabledStyle}
          textStyle={buttonTextStyle}
          disabledTextStyle={buttonDisabledTextStyle}
          testKey={itemButtonAccessibilityLabel}
        />
      ) : null}
    </TouchableOpacity>
  );
};

ListItem.defaultProps = {
  containerStyle: {},
  textStyle: {},
  leftIconType: IconTypes.image,
  leftIconSize: 30,
  leftIconColor: '#000000',
  leftIconStyle: {},
  showRightIcon: false,
  rightIconType: IconTypes.simpleLine,
  rightIconSize: 30,
  rightIconColor: '#000000',
  rightIconStyle: {},
  isClickable: true,
  buttonDisabled: false,
  buttonStyle: {},
  buttonDisabledStyle: {},
  buttonTextStyle: {},
  buttonDisabledTextStyle: {},
  theme: LightThemeColors,
};

ListItem.propTypes = {
  title: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  containerStyle: ViewPropTypes.style,
  textStyle: TextPropTypes.style,
  leftIconType: PropTypes.oneOf(IconTypesValues).isRequired,
  leftIconName: PropTypes.string.isRequired,
  leftIconSize: PropTypes.number,
  leftIconColor: colorPropType,
  leftIconStyle: ViewPropTypes.style,
  showRightIcon: PropTypes.bool,
  rightIconType: PropTypes.oneOf(IconTypesValues),
  rightIconName: PropTypes.string,
  rightIconSize: PropTypes.number,
  rightIconColor: colorPropType,
  rightIconStyle: ViewPropTypes.style,
  isClickable: PropTypes.bool,
  buttonDisabled: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonStyle: ViewPropTypes.style,
  buttonDisabledStyle: ViewPropTypes.style,
  buttonTextStyle: TextPropTypes.style,
  buttonDisabledTextStyle: TextPropTypes.style,
  buttonType: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  index: PropTypes.number,
  images: PropTypes.object,
  itemAccessibilityLabel: PropTypes.string,
  itemIconAccessibilityLabel: PropTypes.string,
  itemArrowAccessibilityLabel: PropTypes.string,
  itemButtonAccessibilityLabel: PropTypes.string,
  itemTitleAccessibilityLabel: PropTypes.string,
  itemRightIconAccessibilityLabel: PropTypes.string,
};

export default withTheme(ListItem);
